/**
 * Module dependencies.
 */

import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useQuery } from '@tanstack/react-query';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';

/**
 * Types.
 */

export type ComponentStatus = 'operational' | 'degraded' | 'down';

export type HealthComponent = {
  key: string;
  latencyMs?: number;
  name: string;
  status: ComponentStatus;
};

export type HealthStatus = {
  checkedAt: string;
  components: HealthComponent[];
  status: ComponentStatus;
};

/**
 * Export `useHealthStatus` — polls the public service status every 30s.
 */

export function useHealthStatus() {
  const client = useRequestProvider();

  return useQuery<HealthStatus>(['health-status'], {
    queryFn: async () => client.get(resolveAppUrl('healthStatus')).then(({ data }: { data: any }) => data?.data),
    refetchInterval: 30000,
    refetchOnWindowFocus: true
  });
}
